export default {
  // async
  SET_TABLE_2: 'SET_TABLE_2',
  SET_LEGENDA2: 'SET_LEGENDA2',
  SET_SITUATION_2: 'SET_SITUATION_2',
  // fetches black cells with only fold
  SET_FIRST_PAIR_2: 'SET_FIRST_PAIR_2',
  SET_SECOND_PAIR_2: 'SET_SECOND_PAIR_2',
  SET_PURPLE_2: 'SET_PURPLE_2',

  // sync
  SET_CARD1_2: 'SET_CARD1_2',
  SET_CARD2_2: 'SET_CARD2_2',
  SET_CARD3_2: 'SET_CARD3_2',
  SET_CARD4_2: 'SET_CARD4_2',
  SET_SUIT_2: 'SET_SUIT_2',
  SET_SUIT_QUALITY_2: 'SET_SUIT_QUALITY_2',
  SET_BB_2: 'SET_BB_2',
  SET_TS_2: 'SET_TS_2',
  SET_STAKE_2: 'SET_STAKE_2',
  SET_LOWER_TABLE_BB_2: 'SET_LOWER_TABLE_BB_2',
  CLEAR_REDUCER: 'CLEAR_REDUCER',
  SET_GGPS_2: 'SET_GGPS_2',
};
